import React from 'react';
import ImageUploader from './ImageUploader';

const BloqueEditor = ({ bloques, onChange }) => {
  const mover = (index, dir) => {
    const next = [...bloques];
    const swap = index + dir;
    if (swap < 0 || swap >= next.length) return;
    [next[index], next[swap]] = [next[swap], next[index]];
    onChange(next);
  };

  const actualizar = (index, fields) => {
    const next = [...bloques];
    next[index] = { ...next[index], ...fields };
    onChange(next);
  };

  const eliminar = (index) => onChange(bloques.filter((_, i) => i !== index));

  const agregarTexto = () => onChange([...bloques, { type: 'text', content: '' }]);
  const agregarImagen = () => onChange([...bloques, { type: 'image', url: '' }]);

  return (
    <div className="bloque-editor">
      {bloques.map((bloque, i) => (
        <div key={i} className="bloque-item">
          <div className="bloque-controls">
            <span className="bloque-tag">{bloque.type === 'image' ? 'IMAGEN' : 'TEXTO'}</span>
            <div className="bloque-arrows">
              <button type="button" onClick={() => mover(i, -1)} title="Subir">▲</button>
              <button type="button" onClick={() => mover(i, 1)} title="Bajar">▼</button>
            </div>
            <button type="button" className="bloque-delete" onClick={() => eliminar(i)} title="Eliminar">✕</button>
          </div>
          {bloque.type === 'text' ? (
            <textarea
              value={bloque.content}
              onChange={e => actualizar(i, { content: e.target.value })}
              rows={4}
              placeholder="Texto del bloque..."
            />
          ) : (
            <ImageUploader
              folder="eventos"
              currentUrl={bloque.url}
              onUpload={url => actualizar(i, { url })}
            />
          )}
        </div>
      ))}
      <div className="bloque-add">
        <button type="button" className="admin-btn" onClick={agregarTexto}>+ Agregar texto</button>
        <button type="button" className="admin-btn" onClick={agregarImagen}>+ Agregar imagen</button>
      </div>
    </div>
  );
};

export default BloqueEditor;
